// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-a"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 12L8 6C8 5.44772 8.44772 5 9 5L15 5C15.5523 5 16 5.44772 16 6V12M8 12L8 19M8 12H16M16 12V19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersAIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-a',
    ref,
    icon: element,
  },
));

LettersAIcon.displayName = 'LettersAIcon';

export default LettersAIcon;
